/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';

export class KnowledgeHubDynamicContentIndexRoute extends Route {
  @service declare appService: $TSFixMe;

  reactEnabled() {
    return this.appService.app.canUseTeamKfDynamicContentForArticles;
  }
}

export default ReactRoute(KnowledgeHubDynamicContentIndexRoute);
